import ReactDOM from "react-dom";
import BitsApp from "./BitsApp";
import "./styles/Index.css";
import "./styles/swal.css";
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloProvider,
  ApolloLink
} from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import { firebase } from './firebase/firebase-config';
import { AttentionAlert2 } from "./alerts/attentionAlert2";

// Enlace HTTP hacia el servidor GraphQL
const httpLink = new HttpLink({   
  uri: process.env.REACT_APP_APOLLO_SERVER,
  fetchOptions: {
    timeout: 90000, 
  },
});

// Middleware para agregar el token en los headers
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token"); // Obtener el token de localStorage
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (
        err.extensions?.code === "INTERNAL_SERVER_ERROR" &&
        err.message.includes("Token no permitido")
      ) {
        //console.warn("Token inválido, redirigiendo al login...");
        firebase.auth().signOut();
        localStorage.removeItem("token");

        // Ejecutar la alerta sin retornar la promesa
        void AttentionAlert2({ text: "Tu sesión ha expirado." });     
      }
    }
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});



// Configurar Apollo Client con autenticación
const client = new ApolloClient({
  cache: new InMemoryCache(),
  //link: authLink.concat(httpLink), // Concatena authLink con httpLink
  link: ApolloLink.from([authLink, errorLink, httpLink]),
});

if ("Notification" in window && Notification.permission !== "granted") {
  Notification.requestPermission().then(() => {
    console.log("Notification granted")
  })
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <BitsApp />
  </ApolloProvider>,
  document.getElementById("root")
);
